import { render, staticRenderFns } from "./AlertasPaciente.vue?vue&type=template&id=6321d62a"
import script from "./AlertasPaciente.vue?vue&type=script&lang=js"
export * from "./AlertasPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports